import { ReturnTotalsType } from "@redotech/redo-model/returns/return-totals/return-totals-set";
import { ReturnSummaryTotalsSchema } from "@redotech/redo-model/returns/return-totals/types";
import * as z from "zod/v4";

export const getReturnTotals = {
  name: "getReturnTotals" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({
    returnSummaryTotals: ReturnSummaryTotalsSchema,
    returnTotalsTypeToUse: z.enum(ReturnTotalsType),
  }),
};
